import { InjectionToken } from '@angular/core';

export interface ApiConfig {
  baseUrl: string;
  baseUrlV2: string;
  recaptchaSiteKey: string;
  appName: string;
}

export const API_CONFIG = new InjectionToken<ApiConfig>('API_CONFIG');
